import React, { Component } from 'react';
import Select from 'react-select';
import { loadFontStyle } from '../../on-boarding/utils';

export default class CustomSelect extends Component {
  handleChange = (values) => {
    this.props.onChange([this.props.name], values);
    if (this.props.onChangeValue) this.props.onChangeValue([this.props.name], values);
  };

  handleBlur = () => {
    this.props.onBlur([this.props.name], true);
  };

  render() {
    const {
      name,
      options,
      value,
      isMulti,
      placeholder,
      isCustomFont = false,
      isDisabled = false,
    } = this.props;
    const colourStyles = {
      control: (styles) => ({ ...styles, backgroundColor: '#fff' }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        let loadedFont = null;
        if (isCustomFont) {
          const fontName = data && data.value && data.value.family ? data.value.family : '';
          const fontStyleObj = fontName ? loadFontStyle(fontName) : {};
          loadedFont = fontStyleObj.fontFamily || null;
        }
        return {
          ...styles,
          fontSize: '0.875rem',
          fontFamily: loadedFont,
          backgroundColor: isDisabled
            ? null
            : isSelected
            ? '#1ba7ae'
            : isFocused
            ? '#1ba7ae9c'
            : null,

          ':active': {
            ...styles[':active'],
            backgroundColor: !isDisabled && (isSelected ? '#fff' : '#1ba7ae'),
          },
        };
      },
      singleValue: (styles, { data, isMulti }) => {
        let loadedFont = null;
        if (isCustomFont && !isMulti) {
          const fontName = data && data.value && data.value.family ? data.value.family : '';
          const fontStyleObj = fontName ? loadFontStyle(fontName) : {};
          loadedFont = fontStyleObj.fontFamily || null;
        }
        return {
          ...styles,
          fontFamily: loadedFont,
        };
      },
    };

    return (
      <Select
        name={name}
        isMulti={isMulti}
        className="custom-select-container"
        classNamePrefix="custom-select"
        options={options}
        value={value}
        onChange={this.handleChange}
        styles={colourStyles}
        placeholder={placeholder || 'Select'}
        isClearable={true}
        isDisabled={isDisabled}
      />
    );
  }
}
